<template>
  <div class="singleReport">     
      <md-empty-state v-if="!myCart.items.length"
            md-icon="lock"
            md-label="Nothing to see here."
            md-description="This report either doesn't exist, or it doesn't belong to you.">
      </md-empty-state>   

<md-table style="margin-top:40px;" v-if="myCart.items.length">
      <md-table-toolbar style="border-bottom:1px solid #333;">
      <div class="md-title">Single Report: {{cartId}}</div>  
        <md-button v-on:click="downloadCSV" class="md-primary md-fab">
          <md-icon>cloud_download</md-icon>
        </md-button>
      </md-table-toolbar>
      
    <md-table-row>
      <md-table-head>UPC</md-table-head>
      <md-table-head>Food</md-table-head>
      <md-table-head>Category</md-table-head>
      <md-table-head>Quantity</md-table-head>
      <md-table-head>Rank</md-table-head>
    </md-table-row>

    <md-table-row v-bind:key="index" v-for="(food, index) in myCart.items" >
      <md-table-cell><md-field><md-input v-model="food.upc">{{food.upc}}</md-input></md-field></md-table-cell>
      <md-table-cell><md-field><md-input v-model="food.item_name">{{food.item_name}}</md-input></md-field></md-table-cell>
      <md-table-cell>
        <md-field>
          <md-select v-model="food.rankings.swap.category" name="category">
              <md-option v-bind:key="index" v-for="(cat,index) in $store.state.swapOptions" :value="cat.value">{{ cat.label }}</md-option>
          </md-select>
        </md-field>
      </md-table-cell>
      <md-table-cell><md-field><md-input v-model="food.quantity">{{food.quantity}}</md-input></md-field></md-table-cell>
      <md-table-cell>
          <md-field>              
            <md-select v-model="food.rankings.swap.rank" name="rank">
                <md-option v-bind:key="index" v-for="(rank,index) in $store.state.swapRankings" :value="rank.value">{{ rank.label }}</md-option>
            </md-select>
          </md-field>
          </md-table-cell>
    </md-table-row>
  </md-table>      
       <!-- <h1 v-bind:key="index" v-for="(food, index) in myCart.items">{{food.item_name}}</h1> -->

  </div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: 'SingleReport',
  data () {
    return {
        myCart:{
            name:this.cartId,
            items:[]
        }
    }
  },
  computed: {

  },

  methods: {
      cart: function (){
            let that = this;
            if(this.$store.state.settings.userId) {
                var db = firebase.firestore();
                var ret = [];
                var docRef = db.collection("users")
                .doc(this.$store.state.settings.userId)
                .collection("carts")
                .doc(this.cartId);

                docRef.get().then(function(doc) {
                if (doc.exists) {
                    console.log("We got it!");
                
                    let c = doc.data().items
                    c.forEach(element => {
                      console.log(element);
                    });
                    that.myCart.items = c;
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            } else {
                console.log("You're not logged in");
            }
      },


    ConvertToCSV(objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = '';

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line != '') line += ','

                    line += array[i][index];
                }

                str += line + '\r\n';
            }

            return str;
        },

      downloadCSV: function() {

        var items = this.myCart.items;
        var exp = [];
         
        for (var i = 0; i < items.length; i++) {
            var row = items[i];
            if (!row.item_name)
                row.item_name = " ";
            exp.push ({
                cartID: this.cartId,
                food:row.item_name.replace(/,/g, ''),
                upc: row.upc,
                category:row.rankings.swap.category,
                quantity:row.quantity,
                rank:row.rankings.swap.rank
            });
        }
        
        exp.unshift(["CartID", "Food Name", "UPC", "Quantity", "Rank"]);

        
        let csvContent = "data:text/csv;charset=utf-8,"
         csvContent += this.ConvertToCSV(exp);


         var encodedUri = encodeURI(csvContent);
          var link = document.createElement('a');
        link.setAttribute('href',encodedUri);
        link.setAttribute('download', "cart.csv");
        link.click();
         //window.open(encodedUri, "_blank");

      }

  },

  mounted: function () {
      this.cart();
  },
  props: ['cartId']
}

</script>
